import { render, staticRenderFns } from "./ReplacementKitForm.vue?vue&type=template&id=184bdc34&"
import script from "./ReplacementKitForm.vue?vue&type=script&lang=js&"
export * from "./ReplacementKitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports